<template>
    <div class="loading">
        <div class="loading-box" :style="{ backgroundColor: background || '' }">
            <div class="loading-spinner">
                <div class="lds-ring" v-if="spinner == 'ring'">
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                </div>
            </div>

            <div class="lds-ripple" v-if="spinner == 'ripple'">
                <div></div>
                <div></div>
            </div>
            <div class="lds-dual-ring" v-if="spinner == 'dual-ring'"></div>
            <div class="loading-text">{{typeof text == 'string' ?text:'加载中……'}}</div>
        </div>
    </div>
</template>


<script>
export default {
    name: 'Loading',
    props: ['text'],
    data() {
        return {
            spinner: 'dual-ring', // ripple
            background: 'rgba(0, 0, 0, 0.5)',
            // background:'none',
            // color:'#fff'
        }
    }
}
</script>

<style scoped lang="scss">
$c: #fff;

.loading {
    position: fixed;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    // background: rgba(0, 0, 0, 0.5);
    width: 100%;
    height: 100%;
    z-index: 9999;
    top: 0;
    left: 0;
}

.loading-box {
    // display: flex;
    // align-items: center;
    color: $c;
    padding: 20px 50px;
    border-radius: 5px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
}

.loading-text {
    margin-top: 15px;
}

.lds-ring {
    display: inline-block;
    position: relative;
    width: 64px;
    height: 64px;
}
.lds-ring div {
    box-sizing: border-box;
    display: block;
    position: absolute;
    width: 51px;
    height: 51px;
    margin: 6px;
    border: 6px solid $c;
    border-radius: 50%;
    animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
    border-color: $c transparent transparent transparent;
}
.lds-ring div:nth-child(1) {
    animation-delay: -0.45s;
}
.lds-ring div:nth-child(2) {
    animation-delay: -0.3s;
}
.lds-ring div:nth-child(3) {
    animation-delay: -0.15s;
}
@keyframes lds-ring {
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
}

.lds-ripple {
    display: inline-block;
    position: relative;
    width: 64px;
    height: 64px;
}
.lds-ripple div {
    position: absolute;
    border: 4px solid $c;
    opacity: 1;
    border-radius: 50%;
    animation: lds-ripple 1s cubic-bezier(0, 0.2, 0.8, 1) infinite;
}
.lds-ripple div:nth-child(2) {
    animation-delay: -0.5s;
}
@keyframes lds-ripple {
    0% {
        top: 28px;
        left: 28px;
        width: 0;
        height: 0;
        opacity: 1;
    }
    100% {
        top: -1px;
        left: -1px;
        width: 58px;
        height: 58px;
        opacity: 0;
    }
}

.lds-dual-ring {
    display: inline-block;
    width: 46px;
    height: 46px;
}
.lds-dual-ring:after {
    content: " ";
    display: block;
    width: 46px;
    height: 46px;
    margin: 1px;
    border-radius: 50%;
    border: 5px solid $c;
    border-color: $c transparent $c transparent;
    animation: lds-dual-ring 1.2s linear infinite;
}
@keyframes lds-dual-ring {
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
}
</style>

